// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__KKEcj","signatureBlock":"Footer_signatureBlock__2kOvI","signature":"Footer_signature__2OC4T"};